(function() {
    'use strict';
    angular
        .module('MW.ContactManager.ActiveOnEmptyRow', [])
        .directive('activeOnEmptyRow', function () {
            return {
                restrict: 'E',
                templateUrl: 'icm-web/views/partials/active_on_empty_row',
                scope: {}
            };
        });
}());
